import Base from "../../../base";
import OrderPatrolListLayout from "../layout";

export default class OrderPatrolList extends Base
{
    render() {
        return (
            <OrderPatrolListLayout

            />
        );
    }
}
